import { apiRequest } from '../apiRequest';

export const createTelegramConnectTokenApi = async () => {
  return apiRequest('/admin/notification/telegram-destinations/connect-token', {
    method: 'POST',
    defaultErrorMessage: 'Failed to generate Telegram connect token',
  });
};
